import Cookies from "js-cookie";

const TokenKey = "USER-TOKEN";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token, isExpires) {
  return Cookies.set(TokenKey, token, isExpires ? { expires: 7 } : "");
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getUserInfo() {
  return JSON.parse(localStorage.getItem("user_info")) || {};
}

export function setUserInfo(value) {
  return localStorage.setItem("user_info", JSON.stringify(value));
}

export function removeUserInfo() {
  return localStorage.removeItem("user_info");
}
